import React from 'react';

interface AdminTopbarProps {
    title: string;
}

const AdminTopbar = ({ title }: AdminTopbarProps) => {
    return (
        <header className="admin-topbar">
            <h1 className="admin-topbar-title">
                {title}
            </h1>

            <div className="admin-topbar-actions">
                {/* Actions futures :
                    notifications, profil, paramètres, etc.
                */}
            </div>
        </header>
    );
};

export default AdminTopbar;
